<template>
  <span class="d-inline-block">
    <b-button
      class="m-2"
      size="sm"
      variant="outline-secondary"
      :disabled="verificandoLicenca"
      @click="verificarLicenca"
    >
      <i class="mdi mdi-spin mdi-loading" v-if="verificandoLicenca"></i>
      {{ verificarLicencaTexto }}
    </b-button>
  </span>
</template>

<script>
import ServidorApi from "../../api/servidorApi";

export default {
  name: "verificarLicencaBtn",
  props: {
    servidor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      verificandoLicenca: false,
      abrirNovaLicencaModal: false
    };
  },
  computed: {
    verificarLicencaTexto() {
      return this.verificandoLicenca ? "Verificando..." : "Verificar Licença";
    },
    atualizandoLicencaTexto() {
      return this.verificandoLicenca ? "Atualizando..." : "Atualizar";
    },
    atualizandoLicencaIcon() {
      return this.verificandoLicenca ? "mdi-spin mdi-loading" : "mdi-refresh";
    }
  },
  methods: {
    enviarLicenca(licenca) {
      this.$emit("enviarLicenca", licenca.licencaExpiraEm);
    },
    verificarLicenca() {
      this.verificandoLicenca = true;
      ServidorApi.verificarLicenca(this.servidor.id)
        .then(data => {
          this.verificandoLicenca = false;
          this.$emit("enviarLicenca", data.licencaExpiraEm);
        })
        .catch(e => {
          console.log(e);
          this.verificandoLicenca = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
